import { LocalStorage } from './LocalStorage';
import _isEmpty from 'lodash/isEmpty';


let auth = {};

const storage = new LocalStorage();

class Authentication {
    constructor() {
        this.user = storage.get('current_user') || {};
    }

    is_loggedin() {
        return _isEmpty(this.user) === false;
    }

    set_user(user) {
        storage.set('current_user', user);
        this.user = user;
    }

    remove_user() {
        storage.remove('auth_headers');
        storage.remove('current_user');
        this.user = {};
    }
}

const initAuthentication = () => {
    auth = new Authentication();
}

initAuthentication();

export { auth };
